
import { defineStore } from "pinia";
import { ref } from 'vue'

export const useAccordionState = defineStore("accordionState", ()=>{
    const accordionState = ref({});
    const toggleAccordion = (key:string, $event:Object|Boolean|null = null)=>{
        if(key) accordionState.value[key] = $event ? ($event?.target?.open || $event === true) : !accordionState.value[key]
    }
    return {accordionState, toggleAccordion}
});